import {closeModal} from "../../../../default/global/js/modal";
import {XhrService} from "../../../../default/global/ts/xhr.service";
import {appendScriptToDOM} from "../../../../default/global/js/utilities/functions";
import {updateItemlistStickyOrderBarCount} from "../../../../default/global/js/itemlistStickyOrderBar";
import {updateHeaderBasket} from "./basket";
import {loadScript} from "../../../../default/global/js/utilities/loadScript";

export function initPconSetup() {
    const cartButton = document.querySelector("[data-modal='modalPcon']");
    const pconModal = document.getElementById("modalPcon");
    const pconIframe = document.getElementById("pConFrame");
    if (!pconIframe || !pconModal || !cartButton) return;
    cartButton.removeAttribute("disabled");
    initRefreshBasketFunction();
    initClosePconModal();
    loadScript("https://ui.pcon-solutions.com/static/js/iframeResizer.min.js").then(response => {
        iFrameResize({
            log: false, waitForLoad: true, checkOrigin: false,
            resizedCallback: function (data) {
                if (data.height > 16) {
                    pconIframe.style.minHeight = data.height + "px";
                }
            }
        }, '#pConFrame');
    });
    pconModal.addEventListener('visible.modal', () => {
        if (pconIframe.dataset.src) {
            pconIframe.src = pconIframe.dataset.src;
            pconIframe.removeAttribute('data-src');
        }
    });
    pconModal.addEventListener('hidden.modal', () => {
        if (pconIframe.src) {
            pconIframe.dataset.src = pconIframe.src;
            pconIframe.removeAttribute('src');
        }
    });

    function initRefreshBasketFunction() {
        window.refreshBasket = refreshBasketHeaderForPcon;
    }

    function initClosePconModal() {
        window.closePconModal = closePconModal;
    }

    function closePconModal() {
        closeModal(pconModal);
    }
    function refreshBasketHeaderForPcon() {
        let formData = new FormData();
        XhrService.generalAjaxCall('readCart', formData, 'POST', 'json').then(response => {
            if (!response.status) {
                throw "Could not save data";
            }
            const headerBasket = document.querySelector('.js-headerBasket');
            if (headerBasket && response.headerBasketContent) {
                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                updateHeaderBasket(doc);
            }
            if (response.tagManager) {
                appendScriptToDOM(response.tagManager, true);
            }
            updateItemlistStickyOrderBarCount();
            return response.status;
        })
            .catch((e) => {
                console.error('Error:', e);
                console.error(formData);
            });

    }
}